import React, { useState, useEffect } from 'react';
import { LeftIcon } from 'tt-ui-lib/icons';
import { Button } from 'tt-ui-lib/core';
import styles from './index.module.scss';
import { useSelectedContext } from 'context/contextSelector';
import { useNavigate } from 'react-router';
import { URL_CUSTOM_REPORTS_DRAFTS, URL_SUST_REPORTS_DRAFTS } from 'constants/calculatorsPage';
import { getDraftData, getReportDraftById } from 'api/reports/endpoints/reports';
import ReportAccordion from 'views/ScoreAndReporting/components/ReportAccordion/ReportAccordion';
import ReportGenerate from 'views/ScoreAndReporting/components/ReportGenerate/ReportGenerate';
import ReportDelete from 'views/ScoreAndReporting/components/ReportDelete/ReportDelete';
import ReportProceed from 'views/ScoreAndReporting/components/ReportProceed/ReportProceed';
import SustReportDefaultAnswers from './SustReportDefaultAnswers';

const DRAFT_URL = URL_SUST_REPORTS_DRAFTS;

const SustReportDraftDetails = ({ params }) => {
  const { user } = useSelectedContext((context) => context.user);
  const { id, setErrorText, setOpenErrorAlert } = params;
  const navigate = useNavigate();

  const [isLoaded, setIsLoaded] = useState(false);
  const [draft, setDraft] = useState(null);
  const [answers, setAnswers] = useState(null);

  const onProceedDraft = () => {
    window.location.replace(`${process.env.REACT_APP_REPORT}/editReport/${id}`);
  };

  const returnToDrafts = () => navigate(DRAFT_URL);

  const onError = (err) => {
    console.log(err);
    setOpenErrorAlert(true);
    setErrorText(err.message ?? 'Something went wrong');
  };

  const getReport = () => {
    getDraftData({ id: id })
      .then((resp) => {
        const { data, success } = resp?.data ?? {};
        if (success) {
          setDraft(data);
          const newAnswers = (data.answers ?? []).reduce((acc, item, index) => {
            const { topic } = item;
            if (!acc.some((t) => t.label === topic)) {
              acc.push({ key: topic, label: topic, children: [] });
            }
            acc
              .find((t) => t.label === topic)
              .children.push({
                key: item.code,
                label: item.question,
                index: index + 1,
                icon: null,
                type: item.type,
                answer: item?.answer,
              });
            return acc;
          }, []);
          if (newAnswers.length) setAnswers(newAnswers);
        }
      })
      .catch((err) => onError(err))
      .finally(() => setIsLoaded((prev) => ({ ...prev, report: true })));
  };

  useEffect(() => {
    if (!id) return;
    getReport();
  }, []);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headerBlock}>
        <button type="button" className={styles.returnButton} onClick={returnToDrafts}>
          <LeftIcon style={{ width: '20px', height: '20px' }} />
          <h2>{draft?.name}</h2>
        </button>
        <ReportProceed
          onProceedDraft={onProceedDraft}
          // buttonType="link"
        />
        <ReportDelete
          draftId={draft?.id}
          draftName={draft?.name}
          onError={onError}
          onDelete={returnToDrafts}
        />
      </div>
      {/* reportId, buttonType */}
      <div className={styles.buttonsPanel}>
        <ReportGenerate reportId={draft?.reportId} reportType="ghg_report" onError={onError} />
      </div>
      <div className={styles.answersContainer}>
        {answers && (
          <ReportAccordion
            data={answers}
            renderAnswer={(answer) => <SustReportDefaultAnswers answer={answer} />}
          />
        )}
        {!answers && isLoaded && `You don't have results yet.`}
        {!isLoaded && `Loading...`}
      </div>
    </div>
  );
};

export default SustReportDraftDetails;
